import { render } from "./NewsSlider.vue?vue&type=template&id=b2293cdc"
import script from "./NewsSlider.vue?vue&type=script&lang=js"
export * from "./NewsSlider.vue?vue&type=script&lang=js"

import "./NewsSlider.vue?vue&type=style&index=0&id=b2293cdc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__